import React from "react";

interface V3PriceDisplayProps {
  amount: number;
  loading?: boolean;
  size?: number;
  suffix?: string;
}

const V3PriceDisplay: React.FC<V3PriceDisplayProps> = ({
  amount,
  loading,
  size = 72,
  suffix,
}) => {
  const safe = Number.isFinite(amount) ? amount : 0;
  const [intPart, decimals] = safe.toFixed(2).split(".");

  return (
    <div
      className={`upsell-v3-priceDisplay${loading ? " upsell-v3-priceDisplay--loading" : ""}`}
      style={{ fontSize: size }}
    >
      <span className="upsell-v3-priceDisplay-int">{intPart}</span>
      <span
        className="upsell-v3-priceDisplay-cents"
        style={{ fontSize: size * 0.36 }}
      >
        ,{decimals}€
      </span>
      {suffix && (
        <span
          className="upsell-v3-priceDisplay-suffix"
          style={{ fontSize: size * 0.22 }}
        >
          {suffix}
        </span>
      )}
      {loading && <span className="upsell-v3-priceDisplay-pulse" aria-hidden="true" />}
    </div>
  );
};

export default V3PriceDisplay;
